// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"CloseButton_closeBtn__Cfz7l"};